/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
import { types } from "mobx-state-tree"

/**
 * Typescript enum
 */

export enum RouteTimelineEventStatus {
  SCHEDULED="SCHEDULED",
COMPLETED="COMPLETED"
}

/**
* RouteTimelineEventStatus
 *
 * Aggregate completion status of a route timeline event (stop or start)
*/
export const RouteTimelineEventStatusEnumType = types.enumeration("RouteTimelineEventStatus", [
        "SCHEDULED",
  "COMPLETED",
      ])
